module.exports = __webpack_public_path__ + "img/jaminan-kepuasan.2aabf36c.svg";